<template>
  <div class="team-members-item">
    <b-row>
      <b-col cols="12" sm="4" md="3" class="text-center">
        <avatar :src="profile.photo" size="6rem" class="m-4" />
      </b-col>
      <b-col>
        <h5 class="mb-3 font-weight-bold">{{userName(profile)}}</h5>
        <b-row>
          <b-col cols="6" md="5" lg="4">
            <kudos-thank :kudos="receivedKudos" :thank="userThanks.received" title="Has received" class="mb-3" />
          </b-col>
          <b-col cols="6" md="5" lg="4">
            <kudos-thank :kudos="givenKudos" :thank="userThanks.given" title="Has given" />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col sm="12" md="3" class="text-center">
      </b-col>
      <b-col v-if="!me" cols="12" sm="4" md="3" class="mb-3">
        <b-button variant="outline-primary" class="w-100" @click="$emit('give-kudo', profile)">
          Give kudos
        </b-button>
      </b-col>
      <b-col v-if="!me" cols="12" sm="4" md="3" class="mb-3">
        <b-button variant="primary" class="w-100" @click="$emit('send-message', profile)">
          Send message
        </b-button>
      </b-col>
      <b-col cols="12" sm="4" md="3" class="mb-3">
        <b-button variant="outline-primary" class="w-100" :to="{ name: 'UserProfile', params: { userId: profile.id } }">
          View profile
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Avatar from '@/components/common/Avatar'
import { KudosThank } from '@/components/KudosList'
import { userName } from '@/helpers/helpers'

export default {
  name: 'TeamMembersItem',

  props: {
    profile: {
      type: Object,
      required: true
    },

    me: {
      type: Boolean,
      default: false
    },

    userKudos: {
      type: Object,
      default: () => ({})
    },

    userThanks: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    receivedKudos() {
      return (this.userKudos.received || []).reduce((out, value) => out + value.count, 0)
    },

    givenKudos() {
      return (this.userKudos.given || []).reduce((out, value) => out + value.count, 0)
    }
  },

  methods: {
    userName(profile) {
      return userName(profile)
    }
  },

  components: {
    Avatar,
    KudosThank
  }
}
</script>
